import { Button, Col, Row } from 'antd'
import React from 'react'
import styled, { css } from 'styled-components'
import Modal, { ModalProps } from './modal/Modal'

export interface GenericPanelProps {
	useStandardMode?: boolean
	children?: React.ReactNode
	width?: number
	title?: React.ReactNode
	description?: React.ReactNode

	okText?: React.ReactNode
	onOk?: (e: React.MouseEvent<HTMLElement>) => void

	cancelText?: React.ReactNode
	onClose?: (e: React.MouseEvent<HTMLElement>) => void
	space?: boolean
	okButtonProps?: any
	closeIcon?: boolean
	buttonType?: ButtonType
}

type ButtonType = 'default' | 'warning'
const GenericPanelWrapper = styled.div<{ useStandardMode: boolean }>`
	padding: 32px 0;
	min-width: 432px;
	min-height: 100px;
	position: relative;
	@media (max-width: 1200px) {
	}
	@media (max-width: 768px) {
		min-width: 0;
		word-break: break-word;
	}

	${({ useStandardMode }) =>
		useStandardMode &&
		css`
			padding: 20px 20px 40px;
			box-shadow: 0 7.1px 70.7px 0 rgba(0, 0, 0, 0.1);
		`}
`

const Header = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 0 20px;
`

const Body = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 20px;
	//margin-top: 24px;

	& > * {
		flex: 1;
	}
`
const StyledButton = styled(Button)<{ disabled?: boolean; buttonType?: ButtonType }>`
	${(props) =>
		props?.disabled
			? css`
					background-color: rgba(27, 27, 41, 0.3) !important;
			  `
			: css`
					background: ${(props) => props.theme.new.colors.sol_indigo_500} !important;

					&:hover {
						background: ${(props) => props.theme.new.colors.sol_indigo_500} !important;
					}
			  `};
`
const Footer = styled.div<{ maxWidth?: boolean; buttonType: ButtonType; disabled?: boolean }>`
	text-align: center;
	padding: 0 40px;

	@media (max-width: 1200px) {
	}
	@media (max-width: 768px) {
		padding: 0 16px;
	}

	.ant-row {
		display: inline-flex;
		width: 100%;
		max-width: ${({ maxWidth }) => (maxWidth ? null : '412px')};
		gap: 12px;
		margin: 0 auto;

		.ant-col {
			margin-top: 24px;
		}

		@media (max-width: 1200px) {
		}
		@media (max-width: 768px) {
			max-width: 100%;
		}
	}

	.buttons-wrapper {
		flex-direction: row;

		button {
			height: 48px;

			span {
				font-size: 16px;
				font-weight: 700;

				@media (max-width: 1200px) {
				}
				@media (max-width: 768px) {
					font-size: 14px;
				}
			}

			&.ant-btn-primary {
				&:not(.ant-btn-background-ghost) {
					span {
						color: #fff;
					}
				}

				&.ant-btn-background-ghost {
					span {
						color: ${(props) => props.theme.new.colors.sol_indigo_500};
					}
				}
			}
		}

		${(props) =>
			props?.buttonType === 'warning' &&
			css`
				button:not(.ant-btn-background-ghost) {
					background-color: #ff5252 !important;
				}

				button.ant-btn-background-ghost {
					background-color: transparent !important;
					border: 1px solid rgb(232, 232, 234) !important;

					> span {
						color: rgba(79, 85, 107) !important;
					}
				}
			`};
		${(props) =>
			props?.disabled &&
			css`
				button:not(.ant-btn-background-ghost) {
					background-color: rgba(27, 27, 41, 0.3) !important;
				}
			`}
	}
`

const PanelTitle = styled.h2`
	font-size: 24px;
	font-weight: 700;
	text-align: center;
	margin: 0;

	.red {
		color: #ff5252;
	}

	@media (max-width: 1200px) {
	}
	@media (max-width: 768px) {
		font-size: 20px;
	}
`

const PanelDescription = styled.p<{ space: boolean }>`
	font-size: 16px;
	text-align: center;
	line-height: 1.5;
	margin-top: ${({ space }) => (space ? '32px' : '8px')};
	margin-bottom: 0;

	.go-btn {
		color: #002fa8;
		text-decoration: underline;
	}

	@media (max-width: 1200px) {
	}
	@media (max-width: 768px) {
		font-size: 14px;
	}
`

export const GenericPanelWithModal: React.FC<GenericPanelProps & ModalProps> = ({
	open,
	width = 640,
	cancelText,
	okText,
	title,
	description,
	onOk,
	onClose,
	children,
	okButtonProps,
	space,
	closeIcon,
	buttonType = 'default',
	...props
}) => {
	return (
		<Modal width={width} onClose={onClose} open={open} {...props}>
			<GenericPanel
				space={space}
				useStandardMode={false}
				cancelText={cancelText}
				okText={okText}
				okButtonProps={okButtonProps}
				title={title}
				description={description}
				onOk={onOk}
				closeIcon={closeIcon}
				buttonType={buttonType}
				onClose={onClose}>
				{children}
			</GenericPanel>
		</Modal>
	)
}

interface GenericPanelCloseIconProps {
	onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
}

export const GenericPanelCloseIcon: React.FC<GenericPanelCloseIconProps> = ({ onClick }) => {
	return (
		<CloseIconBtn onClick={onClick}>
			<span>닫기</span>
		</CloseIconBtn>
	)
}
const CloseIconBtn = styled.button`
	border: none;
	display: block;
	position: absolute;
	background: transparent;
	top: 0;
	right: 0;
	font-size: 0;
	width: 64px;
	height: 64px;
	cursor: pointer;

	> span {
		background: url('/static/assets/icon_close_bold.svg') no-repeat 50% 50%;
		background-size: 32px;
		display: block;
		height: 64px;
	}
`
export const GenericPanel: React.FC<GenericPanelProps> = ({
	children,
	cancelText,
	okText,
	title,
	description,
	onOk,
	onClose,
	useStandardMode = false,
	space,
	okButtonProps,
	closeIcon,
	buttonType,
}) => {
	const handleOnClose = (e) => {
		if (onClose) {
			onClose(e)
		}
	}
	const handleOnOk = (e) => {
		if (onOk) {
			onOk(e)
		}
	}
	return (
		<GenericPanelWrapper useStandardMode={useStandardMode} className={'panel_wrapper'}>
			{(title || description) && (
				<Header className={'panel_header'}>
					<PanelTitle className={'panel_title'}>{title}</PanelTitle>
					{description && (
						<PanelDescription className={'panel_desc'} space={space}>
							{description}
						</PanelDescription>
					)}
				</Header>
			)}
			{closeIcon && <GenericPanelCloseIcon onClick={(e) => handleOnClose(e)} />}
			{children && <Body className={'panel_body'}>{children}</Body>}
			{(okText || cancelText) && (
				<Footer
					maxWidth={okButtonProps?.maxWidth === '100%'}
					className={'panel_footer'}
					buttonType={buttonType}
					disabled={okButtonProps?.disabled}>
					<Row gutter={8} className="buttons-wrapper" justify={'center'}>
						{cancelText && onClose && okText && onOk && (
							<>
								<Col span={11}>
									<Button type="primary" ghost onClick={handleOnClose} block>
										{cancelText}
									</Button>
								</Col>
								<Col span={11}>
									<StyledButton
										className={okButtonProps?.className}
										disabled={okButtonProps?.disabled}
										buttonType={buttonType}
										type="primary"
										onClick={handleOnOk}
										block>
										{okText}
									</StyledButton>
								</Col>
							</>
						)}

						{!cancelText && okText && (
							<Col span={24}>
								<StyledButton
									className={okButtonProps?.className}
									disabled={okButtonProps?.disabled}
									type="primary"
									onClick={(e) => handleOnOk(e)}
									// style={{ backgroundColor: okButtonProps.className==='delete-btn'? 'red':null }}
									block>
									{okText}
								</StyledButton>
							</Col>
						)}
					</Row>
				</Footer>
			)}
		</GenericPanelWrapper>
	)
}
export const genericPanelSmallWidth = css`
	width: 432px !important;
`
